<template>
    <div class="public_container add_project_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="mobile_container add_project_container">
            <van-form colon ref="projectForm" scroll-to-error>
                <ul>
                    <li>
                        <van-field :rules="projectFormRules.project_manage_name" input-align="right" label="项目名称" maxlength="100" placeholder="请输入" required  v-model="projectForm.project_manage_name"></van-field>
                    </li>
                    <li>
                        <van-field :rules="projectFormRules.head_uid" @click="handleClickHeadUser" input-align="right" label="项目负责人" is-link readonly placeholder="请选择" required  v-model="projectForm.head_uid_text"></van-field>
                    </li>
                    <li>
                        <van-field @click="handleClickRelateHandle('select_business')" input-align="right" label="关联商机" placeholder="请选择"  is-link readonly use-button-slot  :value="projectForm.project.map(map => map.project_name).join(',')">
                            <span class="handle_icon_wrap" @click.stop="handleClickRelateHandle('add_business')"  slot="button" >
                                <i class="iconfont icon-a-tianjiamiaobian link-label"></i>
                            </span>
                        </van-field>
                    </li>
                    <li>
                        <van-field @click="handleClickRelateHandle('select_order')" input-align="right" label="关联订单" placeholder="请选择"  is-link readonly use-button-slot  :value="projectForm.order.map(map => map.order_num).join(',')">
                            <span class="handle_icon_wrap" @click.stop="handleClickRelateHandle('add_order')"  slot="button" >
                                <i class="iconfont icon-a-tianjiamiaobian link-label"></i>
                            </span>
                        </van-field>
                    </li>
                    <li>
                        <van-field @click="handleClickRelateHandle('select_work_order')" input-align="right" label="关联工单" placeholder="请选择"  is-link readonly use-button-slot  :value="projectForm.workorder.map(map => map.workorder_num).join(',')">
                            <span class="handle_icon_wrap" @click.stop="handleClickRelateHandle('add_work_order')"  slot="button" >
                                <i class="iconfont icon-a-tianjiamiaobian link-label"></i>
                            </span>
                        </van-field>
                    </li>
                    <li>
                        <van-field @click="showCascaderPicker = true" input-align="right" label="项目地址" placeholder="请选择"  is-link readonly   :value="projectForm.country_region"> </van-field>
                        <van-field v-model="projectForm.addr"  rows="3" autosize  label="" type="textarea" placeholder="请输入详细地址" />
                    </li>
                    <li>
                        <div class="field_item">
                            <div class="field_name">项目概况</div>
                            <div class="field_content">
                                <van-field v-model="projectForm.note"  rows="3" autosize  label="" type="textarea" placeholder="请输入项目概况" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="field_item">
                            <div class="field_name">项目资料</div>
                            <div class="field_content">
                                <div class="file_list" v-if="projectForm.files && projectForm.files.length>0">
                                    <ul>
                                        <li v-for="(file, file_idx) in projectForm.files" :key="file_idx">
                                            <p class="ellipsis" v-text="file.file_name"></p>
                                            <div>
                                                <span @click="handleClickPreview(file)"><i class="iconfont icon-yanjing"></i></span>
                                                <span @click="projectForm.files.splice(file_idx,1)"><i class="iconfont icon-shanchu1"></i></span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="file_note" v-else>支持.rar .zip .doc .docx .pdf .jpg...</div>
                                <div class="file_upload">
                                    <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                                    <i class="iconfont icon-upload"></i>上传附件
                                </div>

                            </div>
                        </div>
                    </li>



                </ul>
            </van-form>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>

        <!-- 人员选择 -->
        <UserSearchSelect :userSelectVisible.sync="userSelectVisible"  :userSelectTitle="'选择人员'" :selectType="'one'" @selectUserData="handleSelectUserData" v-if="userSelectVisible"/>
        <!--选择地址-->
        <van-popup :style="{ height: '480px' }"  position="bottom" round   v-if="showCascaderPicker"  v-model="showCascaderPicker">
            <van-cascader :field-names="cascaderFieldNames" :options="cascaderOptions"  title="选择项目地址"  @close="showCascaderPicker = false"
                          @finish="handleClickCascaderFinish"  active-color="#2990FF"  v-model="cascaderValue">
            </van-cascader>
        </van-popup>
        <!--相关关联的操作-->
        <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
    </div>
</template>

<script>
import {ProjectManageAdd,ProjectManageEdit,ProjectManageDetail,ProjectFileList} from "@/api";
import { ImagePreview } from "vant";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize,getWorldArea,getFileType,removeTag} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
import RelatedHandle from "./component/related_handle.vue";
export default {
    name: "ProjectAdd",
    components: { ReturnNavBar,UserSearchSelect,RelatedHandle},
    data() {
        return {
            btnDisabled:false,
            projectForm:{
                project_manage_name:"",
                head_uid:"",
                head_uid_text:"",
                project:[],
                order:[],
                workorder:[],
                country:'',//国家
                province:'',//省份
                city:'',//城市
                area:'',//地区
                country_region:'',//文本
                addr:"",
                note: "",
                files:[]
            },
            projectFormRules: {
                project_manage_name: [{required: true, message: '请输入项目名称', trigger: 'onBlur'}],
                head_uid: [{required: true, message: '请选择项目负责人', trigger: 'onChange'}],
            },
            loading:false,
            userSelectVisible:false,
            cascaderOptions: getWorldArea("3"),
            showCascaderPicker:false,
            cascaderFieldNames : {
                text: 'label',
                value: 'label',
                children: 'children',
            },
            cascaderValue:''

        };
    },
    created() {

    },
    beforeRouteLeave(to, from, next){
        removeTag(this.$route)
        next();
    },
    methods: {
        // 关联的功能操作
        handleClickRelateHandle(type,data){
            this.$refs.relatedHandle.projectId = this.projectId
            if(type == 'select_order'){
                let pk_sort_project_id = this.projectForm.project.map(item => item.project_id)
                let pk_sort_workorder_id = this.projectForm.workorder.map(item => item.workorder_id)
                let pk_sort = {
                    project_id:pk_sort_project_id,
                    // workorder_id:pk_sort_workorder_id
                }
                data = {
                    select_data:this.projectForm.order,
                    pk_sort:pk_sort
                }
            }else if(type == 'select_business'){
                let pk_sort_id = this.projectForm.order.map(item => item.project_id)
                let pk_sort_workorder_id = this.projectForm.workorder.map(item => item.workorder_id)
                let pk_sort = {
                    id:pk_sort_id,
                    workorder_id:pk_sort_workorder_id
                }
                data = {
                    select_data:this.projectForm.project,
                    pk_sort:pk_sort
                }
            }else if(type == 'select_work_order'){
                let pk_sort_project_id = this.projectForm.project.map(item => item.project_id)
                let pk_sort_order_id = this.projectForm.order.map(item => item.order_id)
                let pk_sort = {
                    order_id:pk_sort_order_id,
                    project_id:pk_sort_project_id,
                }
                data = {
                    select_data:this.projectForm.workorder,
                    pk_sort:pk_sort
                }
            }
            this.$refs.relatedHandle.handleClickRelateHandle(type,data)
        },
        // 关联的操作回调
        relatedHandleSuccess(data){
            if(data.type == 'select_order'){
                this.projectForm.order = data.data.map((item)=>{ return {order_id:item.order_id,order_num:item.order_num,project_id:item.project_id}})
            }else if(data.type == 'select_business'){
                this.projectForm.project = data.data.map((item)=>{ return {project_id:item.project_id,project_name:item.project_name,project_num:''}})
            }else if(data.type == 'select_work_order'){
                this.projectForm.workorder = data.data.map((item)=>{ return {workorder_id:item.id,workorder_num:item.workorder_num, }})
            }
        },
        // 选择项目负责人
        handleClickHeadUser(){
            this.userSelectVisible = true
        },
        // 选择人员回调
        handleSelectUserData(data){
            this.$set(this.projectForm,'head_uid',data.uid)
            this.$set(this.projectForm,'head_uid_text',data.name)
        },
        // 选择项目地址
        handleClickCascaderFinish({selectedOptions}){
            this.projectForm.country = selectedOptions[0]?selectedOptions[0].label : ''//国家
            this.projectForm.province = selectedOptions[1]?selectedOptions[1].label : ''//省份
            this.projectForm.city = selectedOptions[2]?selectedOptions[2].label : ''//城市
            this.projectForm.country_region = selectedOptions.map(option => option.label).join('-')//文本
            this.showCascaderPicker = false
        },

        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            console.log(files);
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.projectForm.files.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            let file_type = getFileType(file.file_name)
            if (file_type && file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file_type && file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickConfirm() {
            this.$refs.projectForm.validate().then(() => {
                let postData = JSON.parse(JSON.stringify(this.projectForm))
                delete  postData.head_uid_text
                this.btnDisabled = true;
                ProjectManageAdd(postData).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message:res.message,
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                removeTag(this.$route)
                                this.$router.go(-1);
                                this.btnDisabled = false
                            },
                        });
                    } else {
                        this.btnDisabled = false;
                    }
                }).catch(() => {
                    this.btnDisabled = false;
                })
            })
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";

</style>
